import { render } from "./ContrattiVenditaDataTable.vue?vue&type=template&id=39fc4b42&scoped=true"
import script from "./ContrattiVenditaDataTable.vue?vue&type=script&lang=js"
export * from "./ContrattiVenditaDataTable.vue?vue&type=script&lang=js"

import "./ContrattiVenditaDataTable.vue?vue&type=style&index=0&id=39fc4b42&lang=css"
import "./ContrattiVenditaDataTable.vue?vue&type=style&index=1&id=39fc4b42&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fc4b42"]])

export default __exports__